import { useEffect, useState, useLayoutEffect, useCallback } from 'react';
import M from 'materialize-css';
import { Link } from 'react-router-dom';
import api from '../../common/api/index.ts';
import mutationHooks from '../../common/mutationHooks/index.ts';
import queryHooks from '../../common/queryHooks/index.ts';
import { useDebounceValue } from '../../common/useDebounce.ts';

const TradingPartner = () => {
  const initValues = () => ({
    name: '',
    globalLocationNumber: '',
    city: '',
    stateId: '',
    type: '',
  });

  const [values, setValues] = useState(initValues());
  const [stateList, setStateList] = useState([]);
  const [loadingStateList, setLoadingStateList] = useState(false);
  const [showInactive, setShowInactive] = useState(false);

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const getStateList = useCallback(async () => {
    try {
      setLoadingStateList(true);
      const stateList = await api.state.read.all();
      setStateList(stateList);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingStateList(false);
    }
  }, []);

  const debouncedValues = useDebounceValue(values, 500);

  const { data: tradingPartnerList } =
    queryHooks.tradingPartner.useReadManyBySearch(debouncedValues);

  useEffect(() => {
    getStateList();
  }, [getStateList]);

  useLayoutEffect(() => {
    M.FormSelect.init(document.querySelectorAll('select'));
    return () =>
      document
        .querySelectorAll('select')
        .forEach(el => M.FormSelect.getInstance(el)?.destroy());
  }, [stateList]);

  const { mutate } = mutationHooks.tradingPartner.useUpdateOne();

  const toggleIsActive = async tradingPartner => {
    mutate({
      ...tradingPartner,
      isActive: !tradingPartner.isActive,
    });
  };

  return (
    <div style={{ paddingTop: '20px' }}>
      <div className="row" style={{ marginBottom: '40px' }}>
        <div className="input-field col s12 m4">
          <input
            id="name"
            type="text"
            value={values.name}
            onChange={onChange}
          />
          <label htmlFor="name">Name</label>
        </div>
        <div className="input-field col s12 m2">
          <input
            id="globalLocationNumber"
            type="text"
            value={values.gln}
            onChange={onChange}
          />
          <label htmlFor="globalLocationNumber">GLN</label>
        </div>
        <div className="input-field col s12 m2">
          <input
            id="city"
            type="text"
            value={values.city}
            onChange={onChange}
          />
          <label htmlFor="city">City</label>
        </div>
        <div className="input-field col s12 m2">
          <select
            id="stateId"
            value={values.stateId}
            onChange={onChange}
            disabled={loadingStateList}
          >
            <option value=""></option>
            {stateList?.map(state => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
          <label htmlFor="stateId">State</label>
        </div>
        <div className="input-field col s12 m2">
          <select id="type" value={values.type} onChange={onChange}>
            <option value=""></option>
            <option value="upstream">Upstream</option>
            <option value="downstream">Downstream</option>
            <option value="both">Both</option>
          </select>
          <label htmlFor="type">Type</label>
        </div>
      </div>
      <div className="card">
        <div className="card-content">
          <div className="row">
            <div class="switch">
              <label>
                <input
                  type="checkbox"
                  value={showInactive}
                  onChange={() => setShowInactive(prev => !prev)}
                />
                <span class="lever"></span>
                Show Inactive
              </label>
            </div>
            <div className="col s12 m4 offset-m8">
              <Link
                to="/tradingpartner/create"
                className="btn-small blue white-text waves-effect waves-light col s12"
              >
                Add Trading Partner
              </Link>
            </div>
          </div>
          <div className="row">
            <table className="highlight">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>GLN</th>
                  <th>City, State</th>
                  <th>Type</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tradingPartnerList
                  ?.filter(({ isActive }) => (showInactive ? true : isActive))
                  .map(
                    ({
                      id,
                      name,
                      type,
                      addresses,
                      globalLocationNumbers,
                      isActive,
                    }) => (
                      <tr key={id}>
                        <td style={{ padding: '2px' }}>
                          <Link
                            to={`/tradingpartner/${id}`}
                            className={!isActive ? 'grey-text' : ''}
                          >
                            {name}
                          </Link>
                        </td>
                        <td style={{ padding: '2px' }}>
                          {globalLocationNumbers?.[0]}
                        </td>
                        <td style={{ padding: '2px' }}>{addresses?.[0]}</td>
                        <td style={{ padding: '2px' }}>{type}</td>
                        <td style={{ padding: '2px' }}>
                          <a
                            href="/"
                            onClick={ev => {
                              ev.preventDefault();
                              toggleIsActive({ id, name, type, isActive });
                            }}
                          >
                            {isActive ? 'Make Inactive' : 'Activate'}
                          </a>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingPartner;
